import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Typography } from 'antd';
import { useDispatch } from 'react-redux';

import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';
import ServiceInfoCell from '@/components/ServiceInfoCell';
import CustomerServicesDetail from '@/components/customer-services/CustomerServicesDetail';
import { getSpecificService } from '@/redux/actions/customerServicesActions';
import { checkPermission } from '@/utils/permission';

const { Text } = Typography;
const CustomerServiceDetailContext = createContext({ canOpen: false, open: null });

/** Dùng chung một modal chi tiết cho toàn bộ table Commission trong cùng page. */
export function CommissionCustomerServiceDetailProvider({ children }) {
    const dispatch = useDispatch();
    const [currentService, setCurrentService] = useState(null);
    const canOpen = checkPermission('customer_services', 'detail');

    const open = useCallback(async customerServiceId => {
        if (!canOpen || !customerServiceId) return;
        try {
            const service = await dispatch(getSpecificService(customerServiceId));
            if (service) setCurrentService(service);
        } catch (error) { /* Redux Action đã hiển thị lỗi. */ }
    }, [canOpen, dispatch]);

    const contextValue = useMemo(() => ({ canOpen, open }), [canOpen, open]);

    return <CustomerServiceDetailContext.Provider value={contextValue}>
        {children}
        <CustomerServicesDetail
            visible={!!currentService}
            currentItem={currentService}
            onCancel={() => setCurrentService(null)}
            allowEdit={false}
            allowCommissionRecalculate={false}
        />
    </CustomerServiceDetailContext.Provider>;
}

/** Chuẩn hóa dữ liệu phẳng/lồng nhau về contract của CustomerInfoColumn. */
export function CommissionCustomerColumn({ customer, record }) {
    const source = customer || record || {};
    const normalized = {
        id: source.id || source.customer_id,
        code: source.code || source.customer_code,
        full_name: source.full_name || source.customer_name,
    };

    if (!normalized.full_name && !normalized.code) return <Text type="secondary">Chưa xác định</Text>;

    return <CustomerInfoColumn
        record={normalized}
        nameField="full_name"
        idField="id"
        codeField="code"
    />;
}

/** ServiceInfoCell dùng callback chung và chỉ bật click khi có permission xem chi tiết. */
export function CommissionServiceColumn({ customerServiceId, service, serviceName, selectedAt, children }) {
    const { canOpen, open } = useContext(CustomerServiceDetailContext);
    const normalizedService = service || { name: serviceName };
    const hasService = !!normalizedService?.name;
    const canOpenDetail = canOpen && !!customerServiceId && hasService;

    return <div>
        {hasService ? <ServiceInfoCell
            service={normalizedService}
            selectedAt={selectedAt}
            showType={false}
            onNameClick={canOpenDetail ? event => {
                event.stopPropagation();
                open(customerServiceId);
            } : null}
            nameTooltip="Xem chi tiết dịch vụ"
        /> : <Text type="secondary">Chưa xác định</Text>}
        {children}
    </div>;
}
